const $ = jQuery;

export default class Accordion {
    constructor() {
        $(document).on('click', '.accordion__title', (e) => {
            let parentOfNotCurrentTarget = $('.accordion__title').not($(e.currentTarget)).parent();
            let parentOfCurrentTarget = $(e.currentTarget).parent();
            let offset = $('.page__header').outerHeight();

            parentOfNotCurrentTarget.find('.accordion__content').slideUp('fast');
            parentOfNotCurrentTarget.find('.accordion__title > span > span').show();
            parentOfNotCurrentTarget.find('.accordion__title > span > span + span').hide();
            parentOfNotCurrentTarget.find('.accordion__icon').removeClass('accordion__icon--rotate180');
            parentOfCurrentTarget.find('.accordion__title > span span')
                    .filter(':visible').hide()
                    .siblings().fadeIn();
            // console.log(parentOfCurrentTarget.offset().top, $(window).scrollTop());
            parentOfCurrentTarget.find('.accordion__content').slideToggle('400', () => {
                if (
                    ((parentOfCurrentTarget.offset().top) < ($(window).scrollTop() + offset)) ||
                    ($('.page__toggle').is(':visible'))
                ) {
                    $('html, body').animate({
                        scrollTop: parentOfCurrentTarget.offset().top - offset
                    }, 200);
                }
            });
            parentOfCurrentTarget.find('.accordion__icon').toggleClass('accordion__icon--rotate180');
        });
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/Accordion.js